import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const rnrApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    startQuarter: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.RNR.START_QUARTER,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Nomination', id: 'ACTIVE' }],
    }),
    addNominationToCategory: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.RNR.ADD_NOMINATION,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Nomination', id: 'LIST' }],
    }),
    setCategoryWinner: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.RNR.SET_WINNER,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Nomination', id: 'LIST' }],
    }),

    //get nomination by quarter and year
    getNominationsByQuarterAndYear: builder.query({
      query: ({ year, quarter }) => {
        return `${ENDPOINTS.RNR.GET_BY_QUARTER_AND_YEAR}${year}/${quarter}`;
      },
      providesTags: (result) =>
        result
          ? [{ type: 'Nomination', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Nomination', id: _id }))]
          : [{ type: 'Nomination', id: 'LIST' }],
    }),
    updateNominationInCategory: builder.mutation({
      query: ({ rnrId, categoryId, nominationId, data }) => ({
        url: `${ENDPOINTS.RNR.UPDATE_NOMINATION}${rnrId}/category/${categoryId}/nomination/${nominationId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { nominationId }) => [{ type: 'Nomination', id: nominationId }],
    }),
    deleteNomination: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.RNR.DELETE_NOMINATION}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Nomination', id: 'LIST' }],
    }),
    getAllNominations: builder.query({
      query: () => ENDPOINTS.RNR.GET_ALL_NOMINATIONS,
      providesTags: (result) =>
        result
          ? [{ type: 'Nomination', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Nomination', id: _id }))]
          : [{ type: 'Nomination', id: 'LIST' }],
    }),
    getNominationById: builder.query({
      query: (id) => `${ENDPOINTS.RNR.GET_NOMINATION_BY_ID}${id}`,
      providesTags: (result, error, id) => [{ type: 'Nomination', id }],
    }),
    getWinnerByEmpCode: builder.query({
      query: (empCode) => `${ENDPOINTS.RNR.GET_WINNER_BY_EMPCODE}${empCode}`,
      providesTags: (result, error, id) => [{ type: 'Nomination', id }],
    }),
    getHistoricalNominations: builder.query({
      query: () => ENDPOINTS.RNR.GET_HISTORICAL_NOMINATIONS,
      providesTags: [{ type: 'Nomination', id: 'HISTORICAL' }],
    }),
    getAllWinners: builder.query({
      query: () => ENDPOINTS.RNR.GET_ALL_WINNERS,
      providesTags: [{ type: 'Nomination', id: 'LIST' }],
    }),
    getNominationsByCategory: builder.query({
      query: (categoryName) => `${ENDPOINTS.RNR.GET_NOMINATIONS_BY_CATEGORY}${categoryName}`,
      providesTags: (result, error, categoryName) => [{ type: 'Nomination', categoryName }],
    }),
    deactivateQuarter: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.RNR.DEACTIVATE_QUARTER}${id}`,
        method: 'PUT',
      }),
      invalidatesTags: [{ type: 'Nomination', id: 'ACTIVE' }],
    }),
    getActiveQuarter: builder.query({
      query: () => ENDPOINTS.RNR.GET_ACTIVE_QUARTER,
      providesTags: (result) => (result ? [{ type: 'Nomination', id: 'ACTIVE' }] : [{ type: 'Nomination', id: 'ACTIVE' }]),
    }),

    getPreviouslyClosedQuarter: builder.query({
      query: () => ENDPOINTS.RNR.GET_PREVIOUS_CLOSED_QUARTER,
      providesTags: (result) => (result ? [{ type: 'Nomination', id: 'ACTIVE' }] : [{ type: 'Nomination', id: 'ACTIVE' }]),
    }),
    
    getNominationByNomineeEmpCode: builder.query({
      query: (empCode) => `${ENDPOINTS.RNR.GET_NOMINATION_BY_NOMINEE_EMPCODE}${empCode}`,
      providesTags: (result) =>
        result?.data
          ? [{ type: 'Nomination', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Nomination', id: _id }))]
          : [{ type: 'Nomination', id: 'LIST' }],
    }),
    getRnRYears: builder.query({
      query: () => ENDPOINTS.RNR.GET_YEARS,
      providesTags: (result) =>
        result?.data
          ? [{ type: 'Nomination', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Nomination', id: _id }))]
          : [{ type: 'Nomination', id: 'LIST' }],
    }),
    getAllEmployees: builder.query({
      query: () => ENDPOINTS.EMPLOYEE.BASE,
      providesTags: (result) =>
        result
          ? [{ type: 'Employee', id: 'List' }, ...result?.map(({ _id }) => ({ type: 'Employee', id: _id }))]
          : [{ type: 'Employee', id: 'List' }],
    }),
  }),
});

export const {
  useStartQuarterMutation,
  useAddNominationToCategoryMutation,
  useSetCategoryWinnerMutation,
  useGetNominationsByQuarterAndYearQuery,
  useUpdateNominationInCategoryMutation,
  useDeleteNominationMutation,
  useGetAllNominationsQuery,
  useGetNominationByIdQuery,
  useGetWinnerByEmpCodeQuery,
  useGetHistoricalNominationsQuery,
  useGetAllWinnersQuery,
  useGetNominationsByCategoryQuery,
  useDeactivateQuarterMutation,
  useGetActiveQuarterQuery,
  useGetNominationByNomineeEmpCodeQuery,
  useGetRnRYearsQuery,
  useGetAllEmployeesQuery,
  useGetPreviouslyClosedQuarterQuery
} = rnrApiSlice;
